export enum VerificationStatus {
    PENDING,
    PASSED,
    FAILED,
}
